// extracted by mini-css-extract-plugin
module.exports = {"total":"RemoteVerificationForm_total__2D7yK","table":"RemoteVerificationForm_table__18i8l"};